var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineReceiptDisscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.94 21.64-1.01-1.35c-.21-.28-.49-.44-.79-.46-.3-.02-.6.12-.84.37l-.57-.5.55.51c-1.45 1.54-2.55 1.42-3.08 1.21-.54-.21-1.45-.9-1.45-3.12V7.04c0-4.44 1.28-5.79 5.47-5.79h7.55c4.19 0 5.47 1.35 5.47 5.79V18.3c0 2.21-.91 2.9-1.45 3.12-.53.21-1.63.33-3.08-1.21-.24-.26-.55-.39-.85-.37-.3.02-.59.18-.8.46l-1.01 1.35c-.51.7-1.26 1.1-2.05 1.1-.79 0-1.54-.4-2.06-1.11zm-1.73-3.31c.74.04 1.44.43 1.91 1.06l1.02 1.35c.49.65 1.24.65 1.73 0l1.01-1.35c.47-.63 1.17-1.02 1.92-1.06.75-.04 1.48.27 2.02.85.76.81 1.25.91 1.43.84.24-.1.5-.68.5-1.72V7.04c0-3.61-.63-4.29-3.97-4.29H8.22c-3.34 0-3.97.68-3.97 4.29V18.3c0 1.05.26 1.63.5 1.72.18.07.67-.03 1.43-.84.52-.55 1.2-.85 1.9-.85h.13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 13c0-.55.45-1 1-1s1 .45 1 1-.44 1-1 1-1-.45-1-1zM8 8c0-.55.45-1 1-1s1 .45 1 1-.44 1-1 1-1-.45-1-1zM8.1 14.33a.754.754 0 0 1 0-1.06l6.73-6.73c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-6.73 6.73a.71.71 0 0 1-.53.22c-.19 0-.38-.07-.53-.22z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineReceiptDisscount);
export default __webpack_public_path__ + "static/media/vuesax-outline-receipt-disscount.1125641df82047e18a4b83fb0fd45dab.svg";
export { ForwardRef as ReactComponent };